import { GenericFieldHTMLAttributes } from 'formik';
import React, { useEffect, useState } from 'react';
import { SupportService } from '../../interfaces/support';
import { PlanChatSupportService } from '../../services/plan-chat-support.service';
import { ContactSupportAIService } from '../../../containers/contact-support-ai/services/contact-support-ai.service';
import useService from '../../../injector/hooks/useService';
import useUserService from '../../../auth/hooks/useUserService';
import { UpgradeToLiveChatDialog } from '../upgrade-to-live-chat-dialog/UpgradeToLiveChatDialog';

export function HdSupportButton({
  Component,
  children,
  message,
  nodeCategory = '',
  onClick,
  ...props
}: {
  Component: React.ComponentType<any>;
  children?: React.ReactNode;
  message?: string;
  nodeCategory?: string;
  onClick?: (result: boolean) => void;
} & Omit<GenericFieldHTMLAttributes, 'onClick'> & {
    [key: string]: any;
  }) {
  const [upgradeToLiveChatConfig, setUpgradeToLiveChatConfig] = useState<{
    open: boolean;
    isCurrentUserOwner?: boolean;
    currentPlanTier?: any;
  }>({
    open: false
  });

  const planChatSupportService = useService(PlanChatSupportService);
  const supportService = useService(SupportService);
  const contactSupportAIService = useService(ContactSupportAIService);
  const { isCurrentUserOwner } = useUserService();

  const initChatSupport = () => {
    const urlMatchingActivate = nodeCategory === 'ACTIVATION';
    const urlMatchingTarget = nodeCategory === 'TARGET';
    if (planChatSupportService.isContactSupportAIEnabled()) {
      if (supportService.isLiveChatOpen()) {
        supportService.hide();
        setTimeout(() => {
          contactSupportAIService.show();
        }, 150);
      } else {
        contactSupportAIService.show();
      }
      return true;
    }

    if (!planChatSupportService.isLiveChatDisabled() || urlMatchingActivate || urlMatchingTarget) {
      
      supportService.show(message);
      return true;
    } else {
      setUpgradeToLiveChatConfig({
        open: true,
        currentPlanTier: planChatSupportService.currentPlanTier,
        isCurrentUserOwner
      });

      return false;
    }
  };

  useEffect(() => {
    const sub = planChatSupportService.liveChatDisabled$.subscribe();

    return () => {
      sub.unsubscribe();
    };
  }, []);

  return (
    <>
      <Component
        {...props}
        onClick={() => {
          const result = initChatSupport();

          if (typeof onClick === 'function') {
            onClick(result);
          }
        }}
      >
        {children}
      </Component>

      <UpgradeToLiveChatDialog
        {...upgradeToLiveChatConfig}
        onClose={() => setUpgradeToLiveChatConfig({ open: false })}
      />
    </>
  );
}
